import { Form, TransformData } from "react-admin"
import { FormChangesTrackerProvider, useFormChangesTracker } from "./FormChangesTracker"
import { PropsWithChildren, ReactNode, useCallback, useEffect } from "react";
import { detailedDiff } from "deep-object-diff";
import { useFormState } from "react-hook-form";


interface TransformProps {
    transform?: TransformData,
    children: ReactNode,
}

type EditOrCreateComponent = <P extends TransformProps>(props: P) => ReactNode

export const SafeUpdateForm = ({ children, EditOrCreate }: PropsWithChildren<{ EditOrCreate: EditOrCreateComponent }>) => {
    return (
        <FormChangesTrackerProvider>
            <EditWithTransform EditOrCreate={EditOrCreate}>
                <Form sanitizeEmptyValues >
                    <FormContentWatcher>
                        {children}
                    </FormContentWatcher>
                </Form>
            </EditWithTransform>
        </FormChangesTrackerProvider>
    )
}

function applyChanges(initial: any, updated: any, changed: any) {
    // Create a copy of the initial object to avoid mutating the original
    const result = { ...initial };

    // Iterate over the keys in the changed object
    for (const key in changed) {
        if (changed[key] === true || Array.isArray(changed[key])) {
            // If the changed value is true, update the result with the updated value
            result[key] = updated[key];
        } else if (typeof changed[key] === 'object' && changed[key] !== null) {
            // If the changed value is an object, recursively apply changes
            result[key] = applyChanges(
                initial[key] || {},
                updated[key] || {},
                changed[key]
            );
        }
    }

    return result;
}


const EditWithTransform = ({ children, EditOrCreate }: PropsWithChildren<{ EditOrCreate: EditOrCreateComponent }>) => {
    const { changes } = useFormChangesTracker();

    const handleTransform = useCallback((data: any, options?: { previousData: any }) => {

        //TODO: handle in the specific place
        //patches
        if (data.searchLocation && !data.searchLocation.coordinates) {
            delete data.searchLocation;
        }



        const result = applyChanges(options?.previousData, data, changes);
        const diff = detailedDiff(options?.previousData, result)
        console.log("transform diff", diff)
        return result;
    }, [changes])
    return (
        <EditOrCreate transform={handleTransform}>
            {children}
        </EditOrCreate>
    )
}

const FormContentWatcher = ({ children }: PropsWithChildren) => {
    const { dirtyFields } = useFormState();
    const { setChanges } = useFormChangesTracker();
    const _change = JSON.stringify(dirtyFields);
    useEffect(() => {
        setChanges(dirtyFields)
    }, [_change, dirtyFields, setChanges])
    return <>{children}</>
}
